function mobileNav() {
  if (window.innerWidth <= 991) {
    const menuItems = document.querySelectorAll('#main-menu > li.nav-item.dropdown > a');
    menuItems.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        this.parentNode.classList.toggle('active');
        let siblings = Array.from(this.parentNode.parentNode.children);
          siblings.splice(siblings.indexOf(this.parentNode), 1); // remove clicked item from sibling list
          siblings.forEach((sibling) => {
            sibling.classList.remove('active');
            sibling.classList.toggle('not-active');
          });
      });
    });
  }

  if (window.innerWidth <= 991) {
    const menuItems = document.querySelectorAll('#footer-menu > li.menu-item-has-children > a');
    menuItems.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        this.parentNode.classList.toggle('active');
        let siblings = Array.from(this.parentNode.parentNode.children);
          siblings.splice(siblings.indexOf(this.parentNode), 1); // remove clicked item from sibling list
          siblings.forEach((sibling) => 
            sibling.classList.remove('active')
          );
      });
    });
  }

  if (window.innerWidth <= 991) {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const mainMenu = document.querySelector('#main-menu');

    navbarToggler.addEventListener('click', function() {
      const menuItems = Array.from(mainMenu.children);

      // Remove 'active' and 'not-active' classes from each menu item
      menuItems.forEach((item) => {
        item.classList.remove('active', 'not-active');
      });
    });
  } else {
    const mainMenu = document.querySelector('#main-menu');
    const menuItems = Array.from(mainMenu.children);
    menuItems.forEach((item) => {
      item.classList.remove('active', 'not-active');
    });
  }
}

window.addEventListener('resize', mobileNav);

mobileNav();

const dropdownMenus = document.querySelectorAll('div.dropdown-menu.nav-item-dropdown-container, div.dropdown-menu.search-dropdown-container');

dropdownMenus.forEach(function(dropdownMenu) {
  dropdownMenu.addEventListener('click', function(event) {
    event.stopPropagation();
  });
});

const privacyPolicyLinks = document.querySelectorAll('.privacy-policy a');
privacyPolicyLinks.forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    this.classList.toggle('active');
  });
});


function mktoPostLoad(formId) {
  console.log('post load function hit')
  const mktoButtonLinks = document.querySelectorAll('.mktoButton');
  if(mktoButtonLinks!==null) {
    mktoButtonLinks.forEach(link => {
      link.setAttribute('id', 'mktoButton');
    });
  }

  const requiredText = document.createElement('p');
  requiredText.classList.add('required');
  requiredText.textContent = 'All fields required';
  
  const targetElement = document.querySelector('.mktoButtonRow');
  if(targetElement!==null) {
    targetElement.appendChild(requiredText);
  }
}



// Footer - Open website link selected in the region select box in a new tab/window

// Get the select element by ID or another selector
const selectElement = document.getElementById('footer-region-select');

// Attach the onchange event listener to the select element
selectElement.onchange = function() {
  // Open new window with selected option value as URL and _blank as target
  window.open(this.options[this.selectedIndex].value, '_blank');
};

$(function () {
  $("[data-bs-toggle='tooltip']").tooltip();
});

//accordion handler
(function($) {
  var allPanels = $('.accordion__container dd').hide();
  var allHeaders = $('.accordion__container .accordion__topic > a');

  $('.accordion__container .accordion__topic > a').click(function(e) {
    var current = $(this);
    var target =  current.closest('dt').next();

    if(!target.hasClass('active')){
      allPanels.removeClass('active').slideUp();
      allHeaders.removeClass('open').addClass('closed');
      current.addClass('open').removeClass('closed');
      target.addClass('active').slideDown();
    }
    else {
      allPanels.removeClass('active').slideUp();
      allHeaders.removeClass('open').addClass('closed');
    }
    return false;
  });

})(jQuery);
  
// Event Cards - Bootstrap Collapse Toggle

document.querySelectorAll('.card-events__card [data-bs-toggle="collapse"]').forEach(function(el) {
  el.addEventListener('click', function() {
    this.classList.toggle('active');
    const svg = this.querySelector('svg');
    const path = svg.querySelector('path:first-of-type');
    if (path.getAttribute('display') === 'none') {
      path.setAttribute('display', 'inline');
    } else {
      path.setAttribute('display', 'none');
    }
    
    let text = this.textContent.trim();
    
    if (this.classList.contains('active')) {
      text = text.replace(/^Show/, 'Hide');
    } else {
      text = text.replace(/^Hide/, 'Show');
    }
    
    this.innerHTML = '';
    this.appendChild(svg);
    this.appendChild(document.createTextNode(text));
  });
});

function setupPCElementClickHandling() {
  const elementsToHandle = [
    {
      sourceContainer: '.webinars-archive__content__results__pills',
      targetContainer: '.webinars-archive__content__results__pills',
      filterContainer: '.webinars-archive__filter',
    },
    {
      sourceContainer: '.product-archive__content__results__pills',
      targetContainer: '.product-archive__content__results__pills',
      filterContainer: '.product-archive__filter',
    },
    {
      sourceContainer: '.resources-archive__content__results__pills',
      targetContainer: '.resources-archive__content__results__pills',
      filterContainer: '.resources-archive__filter',
    },
    {
      sourceContainer: '.partners-archive__content__results__pills',
      targetContainer: '.partners-archive__content__results__pills',
      filterContainer: '.partners-archive__filter',
    },
    {
      sourceContainer: '.customer-stories-archive__content__results__pills',
      targetContainer: '.customer-stories-archive__content__results__pills',
      filterContainer: '.customer-stories-archive__filter',
    },
    // Add more objects for other cases if needed
  ];
  
  elementsToHandle.forEach(function(elementInfo) {
    $(elementInfo.sourceContainer).html('');
  
    $('.pc-element').not('.pc-trigger').clone().appendTo(elementInfo.targetContainer);
  
    $(elementInfo.targetContainer + ' .pc-element .pc-close').each(function() {
      $(this).on('click', function() {
        var dataId = $(this).parent().attr('data-id');
        console.log(dataId);
  
        // Trigger click event on .pc-close elements within .pc-element with the same data-id value
        $(elementInfo.filterContainer + ' .pc-element[data-id="' + dataId + '"] .pc-close').click();
      });
    });
  });  
}

$(document).ready(function() {
  $(document).on("sf:ajaxstart", ".searchandfilter", function(){
    // Call the function to set up the click handling
    setupPCElementClickHandling();
  });
  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    // Call the function to set up the click handling
    setupPCElementClickHandling();
  });
});

$(document).ready(function(){
  const archiveClasses = [
    '.webinars-archive',
    '.product-archive',
    '.resources-archive',
    '.partners-archive',
    '.customer-stories-archive'
  ];
  
  archiveClasses.forEach(function(classSelector) {
    const $inputSelect = $(classSelector + ' .sf-input-select');
    if ($inputSelect.length > 0) {
      $inputSelect.each(function() {
        $(this).picker();
      });
    }
  });
  
  const sections = [
    'webinars-archive', 
    'customer-stories-archive', 
    'partners-archive', 
    'product-archive', 
    'resources-archive'
  ];
  
  sections.forEach(function(section) {
    const $filterTrigger = $(`.${section}__filter-trigger`);
    const $filterClose = $(`.${section}__filter-close`);
    const $filter = $(`.${section}__filter`);
  
    $filterTrigger.on('click', function() {
      $filter.removeClass('d-none');
      $('body').css('overflow', 'hidden');
    });
  
    $filterClose.on('click', function() {
      $filter.addClass('d-none');
      $('body').css('overflow', '');
    });
  });
  

  function togglePCList() {
    var targetPCList = $(this).nextAll('label:first').find('.pc-list');

    // Toggle the d-block class on the target .pc-list element
    targetPCList.toggleClass('d-block');

    // Toggle the active class on the clicked h4 element
    $(this).toggleClass('active');

    // Remove active class from other h4 elements
    $('.searchandfilter h4').not(this).removeClass('active');

    // Remove d-block class from other .pc-list elements
    $('.pc-list').not(targetPCList).removeClass('d-block');
  }

  function checkScreenWidth() {
    if ($(window).width() < 992) {
      $('.searchandfilter h4').on('click', togglePCList);
    } else {
      $('.searchandfilter h4').off('click', togglePCList);
    }
  }

  // Call the checkScreenWidth function on page load
  checkScreenWidth();

  // Call the checkScreenWidth function when the browser is resized
  $(window).on('resize', checkScreenWidth);

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Enter') {
        // Get the currently focused element
        var focusedElement = document.activeElement;

        // Check if the focused element has the class "pc-trigger"
        if (focusedElement.classList.contains('pc-trigger') || focusedElement.classList.contains('pc-list-item')) {
            // Trigger a click event on the focused element
            focusedElement.click();
        }
    }
    if (event.key === 'Escape') {
      // Get the currently focused element
      var focusedElement = document.activeElement;

      // Check if the focused element has the class "pc-trigger"
      if (focusedElement.classList.contains('pc-list-item')) {
        // Find the parent element (first level above)
        var parentElement = focusedElement.parentElement;
        
        // Check if parentElement exists
        if (parentElement) {
          // Find the grandparent element (second level above)
          var grandparentElement = parentElement.parentElement.parentElement;
          
          // Check if grandparentElement exists
          if (grandparentElement) {
            // Find the sibling element with class .pc-trigger
            var siblingTrigger = grandparentElement.querySelector('.pc-trigger');
            
            // Check if siblingTrigger exists
            if (siblingTrigger) {
              // Trigger a click event on the sibling .pc-trigger element
              siblingTrigger.click();
            }
          }
        }
      }
    }
  });
});

// Add toggle for when a search filter is open/close
$(document).ready(function() {
  $('.pc-trigger').on('click', function(event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $('.pc-trigger').not(this).removeClass('active');
  });

  $(document).on('click', function(event) {
    if (!$(event.target).hasClass('pc-trigger')) {
      if (!$(event.target).hasClass('pc-list-item')) {
        $('.pc-trigger').removeClass('active');
      }
    }
  });
});

$(document).ready(function () {
  if ($('.masonry-row').length > 0) {
    var $grid = $('.masonry-row').masonry({
      itemSelector: '.masonry-col',
      percentPosition: true
    });
    $('.card-events__card-event-action__details, .card-events__card-event-action__speakers').on( 'click', function() {
      // trigger layout
      setTimeout(function(){ $grid.masonry(); }, 300);
    });
  }
});